import React from 'react'
import { Col, Row, Radio } from 'antd';


function Secondary({ setSecondaryHazard, newReport, maxHazardsRadios, hazardCharacteristicsRadios, hazardElevationRadios, hazardAspectsRadios, avalancheSizesRadios, hazardLikelihoodRadios, hazardSurfaceConditionsRadios }) {

    const onHazardChange = (value) => {
        const arr = value.split("_")
        const hazardId = parseInt(arr[0])
        const elevationId = parseInt(arr[1])
        // console.log(hazardId);
        setSecondaryHazard({ ...newReport.secondaryHazard, hazardId: hazardId, elevationId: elevationId, characteristicId: 0 })
    }

    var selectedHazard = newReport.secondaryHazard.hazardId + "_" + newReport.secondaryHazard.elevationId

    if (newReport.secondaryHazard.elevationId === 3) {
        // selectedHazard = newReport.secondaryHazard.hazardId + "_" + 1
        for (var i = 0; i < maxHazardsRadios.length; i++) {
            var value = maxHazardsRadios[i].props.children[0].props.value
            var arr = value.split("_");
            if (parseInt(arr[0]) === newReport.secondaryHazard.hazardId) {
                selectedHazard = value;
                break;
            }
        }
    }


    return (
        <div>
            <Row>
                <Col md={12} sm={24}>
                    <h3 className="report-form-h3">Secondary Hazard</h3>
                    <Radio.Group onChange={e => onHazardChange(e.target.value)} value={selectedHazard}>
                        {maxHazardsRadios}
                    </Radio.Group>
                </Col>
            </Row>
            <br />
            <br />
            {
                (newReport.secondaryHazard.hazardId !== 0)
                    ?
                    (newReport.secondaryHazard.hazardId !== 20 && newReport.secondaryHazard.hazardId !== 19 && newReport.secondaryHazard.hazardId !== 18)
                        ?

                        <div>
                            <Row>
                                <Col md={24} sm={24}>
                                    <h3 className="report-form-h3">Avalanche danger</h3>
                                    <Row style={{ marginTop: 10 }}>
                                        <Col md={8} sm={24}>
                                            <label className="report-form-lbl">Hazard characteristics</label>
                                            <br />
                                            <Radio.Group onChange={e => setSecondaryHazard({ ...newReport.secondaryHazard, characteristicId: e.target.value })} value={newReport.secondaryHazard.characteristicId} style={{ marginTop: 5 }}>
                                                {hazardCharacteristicsRadios}
                                            </Radio.Group>
                                        </Col>
                                    </Row>
                                    <br />

                                    {
                                        (newReport.secondaryHazard.characteristicId !== 9)
                                            ?
                                            <Row>
                                                <Col md={24} sm={24} style={{ marginTop: 30 }}>
                                                    <label className="report-form-lbl">Hazard elevation</label>
                                                    <br />
                                                    <Radio.Group onChange={e => setSecondaryHazard({ ...newReport.secondaryHazard, elevationId: e.target.value })} value={newReport.secondaryHazard.elevationId} style={{ marginTop: 5 }}>
                                                        {hazardElevationRadios}
                                                    </Radio.Group>
                                                </Col>

                                                <Col md={24} sm={24} style={{ marginTop: 30 }}>
                                                    <label className="report-form-lbl">Hazard aspect</label>
                                                    <br />
                                                    <Radio.Group onChange={e => setSecondaryHazard({ ...newReport.secondaryHazard, aspectId: e.target.value })} value={newReport.secondaryHazard.aspectId} style={{ marginTop: 5 }}>
                                                        {hazardAspectsRadios}
                                                    </Radio.Group>
                                                </Col>
                                                <Col md={24} sm={24} style={{ marginTop: 30 }}>
                                                    <label className="report-form-lbl">Hazard likelihood</label>
                                                    <br />
                                                    <Radio.Group onChange={e => setSecondaryHazard({ ...newReport.secondaryHazard, likelihoodId: e.target.value })} value={newReport.secondaryHazard.likelihoodId} style={{ marginTop: 5 }}>
                                                        {hazardLikelihoodRadios}
                                                    </Radio.Group>
                                                </Col>
                                                <Col md={24} sm={24} style={{ marginTop: 30 }}>
                                                    <label className="report-form-lbl">Avalanche size</label>
                                                    <br />
                                                    <Radio.Group onChange={e => setSecondaryHazard({ ...newReport.secondaryHazard, avalancheSizesId: e.target.value })} value={newReport.secondaryHazard.avalancheSizesId} style={{ marginTop: 5 }}>
                                                        {avalancheSizesRadios}
                                                    </Radio.Group>
                                                </Col>
                                            </Row>

                                            :

                                            <Row>
                                                <Col md={24} sm={24} style={{ marginTop: 30 }}>
                                                    <label className="report-form-lbl">Hazard elevation</label>
                                                    <br />
                                                    <Radio.Group onChange={e => setSecondaryHazard({ ...newReport.secondaryHazard, elevationId: e.target.value })} value={newReport.secondaryHazard.elevationId} style={{ marginTop: 5 }}>
                                                        {hazardElevationRadios}
                                                    </Radio.Group>
                                                </Col>
                                            </Row>
                                    }


                                    <br />
                                    <Row>
                                        <Col md={24} sm={24}>
                                            <label className="report-form-lbl">Summary</label>
                                            <br />
                                            <textarea className="ant-input text-area-" rows={4} onChange={e => setSecondaryHazard({ ...newReport.secondaryHazard, summary: e.target.value })} value={newReport.secondaryHazard.summary} style={{ marginTop: 5 }} />
                                        </Col>
                                    </Row>

                                </Col>
                            </Row>

                        </div>
                        :

                        <div>
                            <Row>
                                <Col md={24} sm={24}>
                                    {/* <h3 className="report-form-h3">Avalanche danger</h3> */}
                                    <Row>
                                        <Col md={24} sm={24} style={{ marginTop: 30 }}>
                                            <label className="report-form-lbl">Hazard elevation</label>
                                            <br />
                                            <Radio.Group onChange={e => setSecondaryHazard({ ...newReport.secondaryHazard, elevationId: e.target.value })} value={newReport.secondaryHazard.elevationId} style={{ marginTop: 5 }}>
                                                {hazardElevationRadios}
                                            </Radio.Group>
                                        </Col>
                                        <Col md={24} sm={24} style={{ marginTop: 30 }}>
                                            <label className="report-form-lbl">Hazard aspect</label>
                                            <br />
                                            <Radio.Group onChange={e => setSecondaryHazard({ ...newReport.secondaryHazard, aspectId: e.target.value })} value={newReport.secondaryHazard.aspectId} style={{ marginTop: 5 }}>
                                                {hazardAspectsRadios}
                                            </Radio.Group>
                                        </Col>
                                        {/* <Col md={24} sm={24} style={{ marginTop: 30 }}>
                                            <label className="report-form-lbl">Sliding hazard</label>
                                            <br />
                                            <Radio.Group onChange={e => setSecondaryHazard({ ...newReport.secondaryHazard, surfaceConditionId: e.target.value })} value={newReport.secondaryHazard.surfaceConditionId} style={{ marginTop: 5 }}>
                                                {hazardSurfaceConditionsRadios}
                                            </Radio.Group>
                                        </Col> */}
                                    </Row>
                                    <br />
                                    <Row>
                                        <Col md={24} sm={24}>
                                            <label className="report-form-lbl">Summary</label>
                                            <br />
                                            <textarea className="ant-input text-area-" rows={4} onChange={e => setSecondaryHazard({ ...newReport.secondaryHazard, summary: e.target.value })} value={newReport.secondaryHazard.summary} style={{ marginTop: 5 }} />
                                        </Col>
                                    </Row>

                                </Col>
                            </Row>

                        </div>
                    :
                    null
            }
        </div>
    )
}


export default Secondary
